module.exports = __webpack_public_path__ + "img/ic_close.a015bf3c.svg";